const en = {
  // Header
  'header.home': 'Home',
  'header.about': 'About Us',
  'header.brands': 'Brands',
  'header.contact': 'Contact',
  'header.topbar': 'Wholesale Distribution & Consumer Electronics Distribution',
  
  // Introduction
  'intro.title': 'About SMOPTSK',
  'intro.description': 'SMOPTSK is a company located in the heart of Europe, in Slovakia. SMOPTSK is a young and fast-growing company. We are a wholesale distributor of consumer electronics. We offer a wide range of products from leading manufacturers. Our goal is to provide our customers with the best products at the best prices.',
  'intro.mission.title': 'Our Mission',
  'intro.mission.description': 'To provide quality products and excellent service to our customers.',
  'intro.vision.title': 'Our Vision',
  'intro.vision.description': 'To become the leading distributor of consumer electronics in Europe.',
  
  // Statistics
  'stats.years': 'Years of Experience',
  'stats.products': 'Products',
  'stats.brands': 'Brands',
  'stats.countries': 'Countries',
  
  // Brands
  'brands.title': 'Our Brands',
  'brands.subtitle': 'We work with the best brands in the market',
  
  // Worldwide Delivery
  'delivery.title': 'Worldwide Delivery',
  'delivery.subtitle': 'We deliver to all European countries',
  'delivery.description': 'We have a wide network of partners that allows us to deliver products quickly and safely to any European country. Our logistics team ensures that your order arrives on time and in perfect condition.',
  'delivery.fast': 'Fast Delivery',
  'delivery.fast.desc': 'Delivery within 2-5 business days',
  'delivery.secure': 'Secure Packaging',
  'delivery.secure.desc': 'All products are carefully packaged',
  'delivery.tracking': 'Order Tracking',
  'delivery.tracking.desc': 'Track your order in real-time',
  
  // Multi Language
  'multilang.title': 'Multiple Languages',
  'multilang.subtitle': 'We speak your language',
  'multilang.description': 'Our team speaks multiple languages to better serve our customers. We offer support in English, Slovak, Czech, Polish, Hungarian, and German.',
  
  // Customer Care
  'care.title': 'Customer Care',
  'care.subtitle': 'We are here to help you',
  'care.description': 'We prioritize exceptional customer care, a diverse product range, competitive market prices, accelerated delivery times, and an individualized approach tailored to the unique needs of each customer. Our commitment to excellence extends to the timely delivery of our products, facilitated by the collective efforts of our dedicated professional sales and back-office team. At SMOPTSK, we strive to continuously provide exceptional services that align with our core values of quality, efficiency, and customer satisfaction.',
  'care.support': '24/7 Support',
  'care.support.desc': 'We are always available to help',
  'care.warranty': 'Warranty',
  'care.warranty.desc': 'All products come with warranty',
  'care.returns': 'Easy Returns',
  'care.returns.desc': 'Return products within 30 days',
  
  // Footer
  'footer.about': 'About Us',
  'footer.about.desc': 'SMOPTSK is a wholesale distributor of consumer electronics located in Slovakia.',
  'footer.quick.links': 'Quick Links',
  'footer.contact': 'Contact',
  'footer.address': 'Address',
  'footer.phone': 'Phone',
  'footer.email': 'Email',
  'footer.rights': 'All rights reserved.',
  'footer.powered': 'Website Builder',
};

export default en;
